export const AUTH_TOKEN="AUTH_TOKEN";